module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=CO - Colombia.8c15e6c2.svg";